import useResponsive from "./useResponsive";

export default useResponsive;
